import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "lJYt-49ECM",
        width: 940.89,
        height: 394.48,
        left: 29.53,
        top: 133.85,
        viewBox: [940.89, 394.48],
        path: "M 49.31 0 L 891.5799999999999 0 Q 940.89 0 940.89 49.31 L 940.89 345.17 Q 940.89 394.48 891.5799999999999 394.48 L 49.31 394.48 Q 0 394.48 0 345.17 L 0 49.31 Q 0 0 49.31 0 Z",
        fill: "#3f3f46",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#203864",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;"><span style="font-family: 等线;">&nbsp;</span></span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "roundRect",
        keypoint: 0.125,
        lock: true,
      },
      {
        type: "shape",
        id: "KUvkWlTxT4",
        width: 940.89,
        height: 83.23,
        left: 29.58,
        top: 32.03,
        viewBox: [940.89, 83.23],
        path: "M 10.40375 0 L 930.48625 0 Q 940.89 0 940.89 10.40375 L 940.89 72.82625 Q 940.89 83.23 930.48625 83.23 L 10.40375 83.23 Q 0 83.23 0 72.82625 L 0 10.40375 Q 0 0 10.40375 0 Z",
        fill: "rgba(176,122,88,1)",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#203864",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "text",
        id: "XFzzpUFKh_",
        width: 233.59,
        height: 117.953125,
        left: 137.19,
        top: 249.58,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: justify;"><span style="font-size: 97.96px;"><span style="font-family: 汉仪粗简黑简;"><span style="color: #ffffff;">目录</span></span></span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
        shadow: {
          h: 2.21,
          v: 2.21,
          blur: 4.17,
          color: "#00000091",
        },
      },
      {
        type: "shape",
        id: "-1T1K0hN0o",
        width: 15.15,
        height: 15.15,
        left: 45.57,
        top: 66.09,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: "#3f3f46",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#203864",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "6Z4p1QVeXg",
        width: 15.15,
        height: 15.15,
        left: 938.44,
        top: 66.09,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: "#3f3f46",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#203864",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "BGzZQIuWpf",
        width: 258.49,
        height: 48.5625,
        left: 370.76,
        top: 52.24,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: justify;"><strong><span style="font-size: 28.57px;"><span style="font-family: 汉仪粗简黑简;"><span style="color: rgba(255,255,255,1);">CONTENTS</span></span></span></strong></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "shape",
        id: "Nab8s8_s7S",
        width: 38.1,
        height: 19.05,
        left: 182.88,
        top: 381.88,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: "#b07a58",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#203864",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "hd0N05hUOA",
        width: 38.1,
        height: 19.05,
        left: 220.98,
        top: 381.88,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: "#b07a58",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#203864",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "gDYxHwnEhm",
        width: 38.1,
        height: 19.05,
        left: 252.73,
        top: 381.88,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: "#b07a58",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#203864",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "0jfL4ZyrHi",
        width: 38.1,
        height: 19.05,
        left: 284.48,
        top: 381.88,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: "#b07a58",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#203864",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 438.38435695538055,
        top: 200.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#fff",
      },
    ],

    background,
  };
}
